import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { getCatchError } from '../../../getCatchError';

const setPostUpdateBonuses = (params, setOpenModal, setErrorModal) => {
    return async (dispatch, getState) => {
        try {
            const newParams = {
                bonus_name: params.bonus_name,
                currency: params.template,
                percent: params.percent,
                wager: params.wager,
                min_bet: params.min_bet,
                max_bet: params.max_bet,
                max_activation_time: params.max_activation_time,
                max_time_roleplaying: params.max_time_roleplaying,
                min_balance_close_bonus: params.min_balance_close_bonus,
                fix_size_bonus: params.fix_size_bonus,
                bonus_start: new Date(params.bonus_start).getTime(),
                bonus_end: new Date(params.bonus_end).getTime(),
                id: params.id,
                label: params.label,
                min_sum_deposit: params.min_sum_deposit,
                max_sum_deposit: params.max_sum_deposit,
                percent_of_deposit: params.percent_of_deposit,
                wager_percent: params.wager_percent,
                max_size_bonus_of_deposit: params.max_size_bonus_of_deposit,
                promocode: params.promocode,
                cashback_percent: params.cashback_percent,
                min_sum_bonus: params.min_sum_bonus,
                min_sum_balance: params.min_sum_balance,
                day: params.day,
                description: params.description,
                denomination: params.denomination,
                bet_id: params.bet_id,
                total_bets: params.total_bets,
                game_uuid: params.game_uuid,
                quantity: params.quantity
            };

            const { data } = await DefaultApi({
                params: newParams,
                method: 'post',
                url: urls.GET_UPDATE_BONUSES
            });

            if (data.status === 'success') {
                setOpenModal(true);
            }
        } catch (error) {
            //todo доделать catch 
            setErrorModal(true);
            getCatchError(error)
        }
    }
}

export {
    setPostUpdateBonuses as SetPostUpdateBonuses
}